module.exports = __webpack_public_path__ + "img/IMG_2679.014154fb.jpg";